// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"daeec849","194":"ffa18512","472":"3ca223cf","496":"6128b9ba","541":"dc4c17ee","586":"353c2816","658":"24faebd1","672":"68a92d7e","699":"0e732cef","934":"9c118dff"}[chunkId] + ".chunk.js";
};